<script setup lang="ts">
  import { GripVertical } from 'lucide-vue-next';
</script>

<template>
  <div
    class="drag-handle flex h-8 w-6 shrink-0 cursor-move items-center justify-center rounded-lg border border-[var(--color-gray-02)] bg-white-01"
  >
    <GripVertical class="h-5 w-5 text-[var(--color-gray-03)]" />
  </div>
</template>
